module.exports = new __parcel__URL__("species.e324a04b.png").toString();